<template>
  <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
    <img src='~/assets/logo_dark1.png' class="place-items-center mb-10" alt="Ticket Smile" />

    <div class="text-center">
      <p class="text-3xl font-semibold text-pink-600">{{error.statusCode}}</p>
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">{{ error.statusCode == 404? 'Página não encontrada!' : 'Algo deu errado!' }}</h1>
      <p class="mt-6 text-base leading-7 text-gray-600">{{ error.statusCode == 404 ? 'Ops! A página que você procura não existe. Pode ter sido movida ou excluída.':'Desculpe, ocorreu um erro no servidor.' }}</p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <button  @click="handleError"
          class="rounded-md bg-pink-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600">Volte
          para a página inicial</button>
      </div>
    </div>
  </main>
</template>


<script setup>
const props = defineProps({
  error: Object,
  required: true,
});

const handleError = () => clearError({ redirect: '/' });
</script>